<div class="flex flex-col h-screen w-full">
  <app-page-header>
    <div class="flex flex-row justify-start items-center gap-2 h-10">
      <span>Versionsverlauf</span>
    </div>
  </app-page-header>

  <div class="flex-1 w-full overflow-y-auto p-6 min-h-0">
    @if (loading) {
      <div class="text-gray-400 text-sm text-center">Lädt...</div>
    } @else if (entries.length === 0) {
      <div class="text-gray-400 text-sm text-center">Noch keine Versionshinweise vorhanden.</div>
    } @else {
      <div class="flex flex-col gap-6 max-w-[720px] mx-auto">
        @for (entry of entries; track entry.version) {
          <div class="flex flex-col gap-1 border border-gray-200 rounded-lg p-4">
            <div class="flex flex-row justify-between items-baseline">
              <div class="font-semibold text-base text-gray-900">Version {{ entry.version }}</div>
              <div class="text-xs text-gray-400">{{ entry.createdAt | date:'dd.MM.yyyy' }}</div>
            </div>
            @if (entry.title) {
              <div class="font-medium text-sm text-gray-700 mb-2">{{ entry.title }}</div>
            }
            <markdown [data]="entry.rawNotes" class="version-notes"></markdown>
          </div>
        }
      </div>
    }
  </div>
</div>
